<template>
  <div>
    <h1 class="page-title">空置资源管理</h1>

    <div class="query-panel soft-card">
      <div class="query-fields">
        <el-input
          v-model="query.name"
          clearable
          placeholder="资源名称"
          class="query-control"
          @keyup.enter.native="search"
        />
        <el-input
          v-model="query.address"
          clearable
          placeholder="资源地址"
          class="query-control"
          @keyup.enter.native="search"
        />
        <el-input
          v-model="query.summary"
          clearable
          placeholder="资源简介"
          class="query-control"
          @keyup.enter.native="search"
        />
        <el-input
          v-model="query.community"
          clearable
          placeholder="所属社区"
          class="query-control"
          @keyup.enter.native="search"
        />
        <el-select v-model="query.category" clearable placeholder="资源类型" class="query-control">
          <el-option v-for="item in categories" :key="item" :label="item" :value="item" />
        </el-select>
        <el-input
          v-model="query.minArea"
          clearable
          placeholder="最小面积"
          class="query-control"
          @keyup.enter.native="search"
        />
        <el-input
          v-model="query.maxArea"
          clearable
          placeholder="最大面积"
          class="query-control"
          @keyup.enter.native="search"
        />
        <el-select v-model="query.isPublished" clearable placeholder="上下架" class="query-control">
          <el-option label="已上架" :value="1" />
          <el-option label="已下架" :value="0" />
        </el-select>
        <el-select v-model="query.navigationConfigured" clearable placeholder="导航设置" class="query-control">
          <el-option label="是" :value="true" />
          <el-option label="否" :value="false" />
        </el-select>
      </div>
      <div class="query-actions">
        <el-button type="primary" icon="el-icon-search" @click="search">查询</el-button>
        <el-button icon="el-icon-refresh-left" @click="resetQuery">重置</el-button>
      </div>
    </div>

    <div class="page-actions">
      <el-button type="primary" icon="el-icon-plus" @click="openEdit()">新增资源</el-button>
      <el-button icon="el-icon-upload2" @click="importVisible = true">导入</el-button>
      <el-button icon="el-icon-download" @click="exportVisible = true">导出</el-button>
    </div>

    <div v-if="selectedCount" class="selection-bar">
      <div class="selection-summary">
        <span class="selection-icon"><i class="el-icon-check" /></span>
        <span>已勾选 <strong>{{ selectedCount }}</strong> 项空置资源</span>
      </div>
      <el-button type="text" icon="el-icon-close" @click="clearSelected">清空勾选</el-button>
    </div>

    <el-table ref="dataTable" class="soft-card" :data="list" row-key="id" v-loading="loading" @selection-change="handleSelectionChange">
      <el-table-column type="selection" width="52" :reserve-selection="true" />
      <el-table-column type="index" label="序号" width="70" :index="tableIndex" />
      <el-table-column label="封面" width="90">
        <template slot-scope="scope">
          <el-image
            v-if="scope.row.coverFile"
            :src="scope.row.coverFile.url"
            style="width:58px;height:46px;border-radius:8px"
            fit="cover"
          />
        </template>
      </el-table-column>
      <el-table-column prop="title" label="名称" min-width="180" />
      <el-table-column prop="category" label="类型" width="120" />
      <el-table-column prop="resourceType" label="细分类型" width="120" />
      <el-table-column prop="community" label="所属社区" width="120" />
      <el-table-column prop="area" label="面积" width="110" />
      <el-table-column prop="rentStatus" label="状态" width="100" />
      <el-table-column label="导航设置" width="100">
        <template slot-scope="scope">
          <el-tag :type="isNavigationConfigured(scope.row) ? 'success' : 'info'" size="mini">
            {{ isNavigationConfigured(scope.row) ? '是' : '否' }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="sortOrder" label="排序" width="90" />
      <el-table-column label="上架" width="90">
        <template slot-scope="scope">
          <el-switch :value="scope.row.isPublished === 1" @change="value => toggle(scope.row, value)" />
        </template>
      </el-table-column>
      <el-table-column label="操作" width="150">
        <template slot-scope="scope">
          <el-button type="text" size="mini" @click="openEdit(scope.row.id)">编辑</el-button>
          <el-button type="text" size="mini" class="danger-text" @click="remove(scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <div class="pagination-wrap">
      <el-pagination
        background
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        :current-page="query.pageNum"
        :page-size="query.pageSize"
        :page-sizes="[10, 20, 50, 100]"
        @current-change="handlePageChange"
        @size-change="handleSizeChange"
      />
    </div>

    <el-dialog
      :close-on-click-modal="false"
      v-if="visible"
      custom-class="manage-dialog"
      :title="dialogTitle"
      :visible.sync="visible"
      width="1000px"
      top="4vh"
    >
      <el-form
        ref="resourceForm"
        class="manage-form"
        :model="form"
        :rules="rules"
        label-width="132px"
        v-loading="detailLoading"
      >
        <el-form-item label="名称" prop="title">
          <el-input v-model="form.title" clearable />
        </el-form-item>

        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="资源类型" prop="category">
              <el-select v-model="form.category" placeholder="请选择">
                <el-option v-for="item in categories" :key="item" :label="item" :value="item" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="细分类型" prop="resourceType">
              <el-input v-model="form.resourceType" clearable placeholder="例如：写字楼、底商、配套用房" />
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="面积数值" prop="areaValue">
              <el-input v-model="form.areaValue" clearable placeholder="请输入面积，最多两位小数" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="面积单位" prop="areaUnit">
              <el-input v-model="form.areaUnit" disabled />
              <div class="field-tip">当前统一按平方米筛选，单位固定为㎡</div>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="租售状态" prop="rentStatus">
              <el-input v-model="form.rentStatus" clearable placeholder="例如：闲置、可租、可售" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="所属社区">
              <el-input v-model="form.community" clearable />
            </el-form-item>
          </el-col>
        </el-row>

        <el-form-item label="地址" prop="address">
          <el-input v-model="form.address" clearable />
        </el-form-item>

        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="联系人">
              <el-input v-model="form.contactName" clearable />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="联系电话">
              <el-input v-model="form.contactPhone" clearable />
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="纬度" prop="latitude">
              <el-input v-model="form.latitude" clearable />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="经度" prop="longitude">
              <div class="coordinate-input-row">
                <el-input v-model="form.longitude" clearable />
                <a
                  class="coordinate-tool-link"
                  href="https://lbs.qq.com/getPoint/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  在线获取坐标工具网站
                </a>
              </div>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="排序值">
              <el-input-number v-model="form.sortOrder" :min="0" controls-position="right" />
              <div class="field-tip">数值越大越靠前，默认0</div>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="是否上架">
              <el-switch v-model="published" active-text="上架" inactive-text="下架" />
            </el-form-item>
          </el-col>
        </el-row>

        <el-form-item label="简介摘要">
          <el-input v-model="form.summary" type="textarea" :rows="2" />
        </el-form-item>

        <el-form-item label="详细介绍">
          <el-input v-model="form.description" type="textarea" :rows="4" :maxlength="15000" show-word-limit />
        </el-form-item>

        <el-form-item label="配套条件">
          <el-input v-model="form.facilities" type="textarea" :rows="3" />
        </el-form-item>

        <el-form-item label="封面图">
          <el-upload
            :action="uploadAction"
            :headers="uploadHeaders"
            accept=".jpg,.jpeg,.png"
            :before-upload="beforeImageUpload"
            list-type="picture-card"
            :limit="1"
            :file-list="coverUploadList"
            :on-success="onCoverSuccess"
            :on-remove="onCoverRemove"
            :on-change="onCoverChange"
          >
            <i class="el-icon-plus"></i>
          </el-upload>
        </el-form-item>

        <el-form-item label="详情图">
          <el-upload
            :action="uploadAction"
            :headers="uploadHeaders"
            accept=".jpg,.jpeg,.png"
            :before-upload="beforeImageUpload"
            list-type="picture-card"
            multiple
            :file-list="detailUploadList"
            :on-success="onImagesSuccess"
            :on-remove="onImagesRemove"
            :on-change="onImagesChange"
          >
            <i class="el-icon-plus"></i>
          </el-upload>
          <div class="upload-tip">图片按当前列表顺序保存；如需调整顺序，可删除后按顺序重新添加。</div>
        </el-form-item>
      </el-form>

      <span slot="footer">
        <el-button @click="visible = false">取消</el-button>
        <el-button type="primary" :disabled="detailLoading" @click="save">保存</el-button>
      </span>
    </el-dialog>

    <import-dialog
      v-model="importVisible"
      title="空置资源"
      :template-loader="downloadResourceTemplate"
      :preview-loader="previewResourceFile"
      :execute-loader="executeResourceFile"
      @success="handleImportSuccess"
    />
    <export-dialog
      v-model="exportVisible"
      title="空置资源"
      :columns="resourceExportColumns"
      :selection-count="selectedCount"
      :export-loader="exportResourceData"
    />
  </div>
</template>

<script>
import { API_BASE } from '../api/request'
import {
  listResources,
  detailResource,
  saveResource,
  publishResource,
  uploadUrl,
  deleteResource,
  downloadResourceImportTemplate,
  previewResourceImport,
  executeResourceImport,
  exportResources
} from '../api'
import ImportDialog from '../components/ImportDialog.vue'
import ExportDialog from '../components/ExportDialog.vue'
import crossPageSelection from '../mixins/crossPageSelection'
import { downloadBlob } from '../utils/fileDownload'

const empty = () => ({
  id: null,
  title: '',
  category: '楼宇',
  resourceType: '',
  areaValue: '',
  areaUnit: '㎡',
  address: '',
  community: '',
  rentStatus: '闲置',
  contactName: '',
  contactPhone: '',
  latitude: null,
  longitude: null,
  summary: '',
  description: '',
  facilities: '',
  sortOrder: 0,
  isPublished: 1,
  coverFile: null,
  imageFiles: []
})

export default {
  components: { ImportDialog, ExportDialog },
  mixins: [crossPageSelection],
  data() {
    const validateAreaValue = (rule, value, callback) => {
      const areaValue = String(value || '').trim()
      if (!areaValue) {
        callback(new Error('请输入面积数值'))
        return
      }
      if (!/^\d+(\.\d{1,2})?$/.test(areaValue)) {
        callback(new Error('面积数值请输入合法数字，最多保留两位小数'))
        return
      }
      callback()
    }

    const validateCoordinate = (rule, value, callback) => {
      const latitude = String(this.form.latitude === null || this.form.latitude === undefined ? '' : this.form.latitude).trim()
      const longitude = String(this.form.longitude === null || this.form.longitude === undefined ? '' : this.form.longitude).trim()
      const coordinatePattern = /^-?\d+(\.\d+)?$/

      if (!latitude && !longitude) {
        callback()
        return
      }
      if (!latitude || !longitude) {
        callback(new Error('纬度和经度需同时填写'))
        return
      }
      if (!coordinatePattern.test(latitude) || !coordinatePattern.test(longitude)) {
        callback(new Error('经纬度请输入合法数字'))
        return
      }
      if (Number(latitude) < -90 || Number(latitude) > 90) {
        callback(new Error('纬度范围为-90至90'))
        return
      }
      if (Number(longitude) < -180 || Number(longitude) > 180) {
        callback(new Error('经度范围为-180至180'))
        return
      }
      callback()
    }

    return {
      categories: ['楼宇', '沿街商铺', '社区公建房'],
      query: {
        name: '',
        address: '',
        summary: '',
        community: '',
        category: '',
        minArea: '',
        maxArea: '',
        isPublished: null,
        navigationConfigured: null,
        pageNum: 1,
        pageSize: 10
      },
      list: [],
      total: 0,
      loading: false,
      visible: false,
      importVisible: false,
      exportVisible: false,
      detailLoading: false,
      editingId: null,
      form: empty(),
      coverUploadList: [],
      detailUploadList: [],
      resourceExportColumns: [
        { key: 'title', label: '名称' },
        { key: 'category', label: '资源类型' },
        { key: 'resourceType', label: '细分类型' },
        { key: 'areaValue', label: '面积数值' },
        { key: 'areaUnit', label: '面积单位' },
        { key: 'rentStatus', label: '租售状态' },
        { key: 'community', label: '所属社区' },
        { key: 'address', label: '地址' },
        { key: 'contactName', label: '联系人' },
        { key: 'contactPhone', label: '联系电话' },
        { key: 'summary', label: '简介摘要' },
        { key: 'description', label: '详细介绍' },
        { key: 'facilities', label: '配套条件' }
      ],
      rules: {
        title: [{ required: true, message: '请输入资源名称', trigger: 'blur' }],
        category: [{ required: true, message: '请选择资源类型', trigger: 'change' }],
        resourceType: [{ required: true, message: '请输入细分类型', trigger: 'blur' }],
        areaValue: [{ required: true, validator: validateAreaValue, trigger: 'blur' }],
        areaUnit: [{ required: true, message: '面积单位不能为空', trigger: 'change' }],
        address: [{ required: true, message: '请输入地址', trigger: 'blur' }],
        rentStatus: [{ required: true, message: '请输入租售状态', trigger: 'blur' }],
        latitude: [{ validator: validateCoordinate, trigger: 'blur' }],
        longitude: [{ validator: validateCoordinate, trigger: 'blur' }]
      }
    }
  },
  computed: {
    dialogTitle() {
      return this.editingId ? '编辑资源' : '新增资源'
    },
    uploadAction() {
      return API_BASE + uploadUrl
    },
    uploadHeaders() {
      return { Authorization: 'Bearer ' + localStorage.getItem('adminToken') }
    },
    published: {
      get() {
        return this.form.isPublished === 1
      },
      set(value) {
        this.form.isPublished = value ? 1 : 0
      }
    }
  },
  created() {
    this.load()
  },
  methods: {
    isNavigationConfigured(row) {
      return row.latitude !== null
        && row.latitude !== undefined
        && row.latitude !== ''
        && row.longitude !== null
        && row.longitude !== undefined
        && row.longitude !== ''
    },
    load() {
      const query = this.buildQuery()
      if (!query) {
        return
      }
      this.loading = true
      listResources(query)
        .then(result => {
          this.list = result && result.records ? result.records : []
          this.total = result && typeof result.total === 'number' ? result.total : 0
          this.$nextTick(() => this.restoreSelection())
        })
        .finally(() => {
          this.loading = false
        })
    },
    buildQuery() {
      const query = Object.assign({}, this.query, {
        minArea: String(this.query.minArea || '').trim(),
        maxArea: String(this.query.maxArea || '').trim()
      })
      const areaPattern = /^\d+(\.\d{1,2})?$/

      if (query.minArea && !areaPattern.test(query.minArea)) {
        this.$message.warning('最小面积请输入合法数字，最多保留两位小数')
        return null
      }
      if (query.maxArea && !areaPattern.test(query.maxArea)) {
        this.$message.warning('最大面积请输入合法数字，最多保留两位小数')
        return null
      }
      if (query.minArea && query.maxArea && Number(query.minArea) > Number(query.maxArea)) {
        this.$message.warning('最小面积不能大于最大面积')
        return null
      }
      return query
    },
    search() {
      this.query.pageNum = 1
      this.load()
    },
    resetQuery() {
      this.query.name = ''
      this.query.address = ''
      this.query.summary = ''
      this.query.community = ''
      this.query.category = ''
      this.query.minArea = ''
      this.query.maxArea = ''
      this.query.isPublished = null
      this.query.navigationConfigured = null
      this.query.pageNum = 1
      this.load()
    },
    tableIndex(index) {
      return (this.query.pageNum - 1) * this.query.pageSize + index + 1
    },
    handlePageChange(pageNum) {
      this.query.pageNum = pageNum
      this.load()
    },
    handleSizeChange(pageSize) {
      this.query.pageSize = pageSize
      this.query.pageNum = 1
      this.load()
    },
    downloadResourceTemplate() {
      return downloadResourceImportTemplate().then(blob => {
        downloadBlob(blob, '空置资源导入模板.xlsx')
      })
    },
    previewResourceFile(file) {
      return previewResourceImport(file)
    },
    executeResourceFile(file, strategy) {
      return executeResourceImport(file, strategy)
    },
    handleImportSuccess() {
      this.clearSelected()
      this.search()
    },
    exportResourceData(options) {
      const payload = Object.assign({}, options, {
        query: Object.assign({}, this.query),
        selectedIds: this.selectedIds.slice()
      })
      return exportResources(payload).then(blob => {
        downloadBlob(blob, '空置资源导出.xlsx')
      })
    },
    openEdit(id) {
      this.editingId = id || null
      this.form = empty()
      this.coverUploadList = []
      this.detailUploadList = []
      this.visible = true
      this.$nextTick(() => {
        if (this.$refs.resourceForm) {
          this.$refs.resourceForm.clearValidate()
        }
      })
      if (!id) {
        this.detailLoading = false
        return
      }
      this.detailLoading = true
      detailResource({ id })
        .then(result => {
          if (this.editingId !== id) {
            return
          }
          this.form = Object.assign(empty(), result, {
            areaUnit: '㎡',
            imageFiles: result.imageFiles || []
          })
          this.coverUploadList = this.form.coverFile ? [this.form.coverFile] : []
          this.detailUploadList = this.form.imageFiles.slice()
          this.$nextTick(() => {
            if (this.$refs.resourceForm) {
              this.$refs.resourceForm.clearValidate()
            }
          })
        })
        .finally(() => {
          if (this.editingId === id) {
            this.detailLoading = false
          }
        })
    },
    toggle(row, value) {
      publishResource({ id: row.id, isPublished: value ? 1 : 0 }).then(() => {
        this.$message.success('状态已更新')
        this.load()
      })
    },
    beforeImageUpload(file) {
      const allowedTypes = ['image/jpeg', 'image/png']
      const allowedNames = /\.(jpe?g|png)$/i
      const isAllowed = file && (allowedTypes.indexOf(file.type) > -1 || allowedNames.test(file.name))
      if (!isAllowed) {
        this.$message.error('只能上传jpg、jpeg、png图片')
      }
      return isAllowed
    },
    onCoverSuccess(response) {
      if (response.code === 0) {
        this.form.coverFile = response.data
        this.coverUploadList = [response.data]
      }
    },
    onCoverChange(file, fileList) {
      this.coverUploadList = fileList
    },
    onCoverRemove() {
      this.form.coverFile = null
      this.coverUploadList = []
    },
    onImagesSuccess(response, file, fileList) {
      if (response.code === 0) {
        this.detailUploadList = this.mergeUploadSuccess(fileList)
        this.form.imageFiles = this.normalizeFileList(this.detailUploadList)
      }
    },
    onImagesChange(file, fileList) {
      this.detailUploadList = fileList
    },
    onImagesRemove(file, fileList) {
      this.detailUploadList = fileList
      this.form.imageFiles = this.normalizeFileList(fileList)
    },
    mergeUploadSuccess(fileList) {
      return fileList.map(file => {
        if (file.response && file.response.data) {
          return Object.assign({}, file, file.response.data)
        }
        return file
      })
    },
    normalizeFileList(fileList) {
      return fileList
        .map(file => (file.response && file.response.data ? file.response.data : file))
        .filter(file => file.id)
    },
    remove(row) {
      this.$confirm('确认删除该空置资源吗？删除后小程序端将不再展示。', '删除确认', { type: 'warning' })
        .then(() => deleteResource({ id: row.id }))
        .then(() => {
          this.$message.success('已删除')
          this.removeSelected(row.id)
          if (this.list.length === 1 && this.query.pageNum > 1) {
            this.query.pageNum -= 1
          }
          this.load()
        })
        .catch(() => {})
    },
    save() {
      this.form.areaValue = String(this.form.areaValue || '').trim()
      this.form.areaUnit = '㎡'
      this.$refs.resourceForm.validate(valid => {
        if (!valid) {
          return
        }
        saveResource(this.form).then(() => {
          this.$message.success('保存成功')
          this.visible = false
          this.editingId = null
          this.load()
        })
      })
    }
  }
}
</script>

<style scoped>
.danger-text {
  color: #f56c6c;
}

.selection-summary {
  display: flex;
  align-items: center;
  gap: 8px;
  color: #334155;
  font-size: 14px;
}

.selection-summary strong {
  color: #2563eb;
  font-size: 16px;
}

.selection-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  color: #fff;
  background: linear-gradient(135deg, #4f8df7, #2563eb);
}

.selection-bar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  min-height: 46px;
  margin: -4px 0 16px;
  padding: 0 14px;
  border: 1px solid #dbeafe;
  border-radius: 12px;
  background: #f8fbff;
}

.selection-bar .el-button {
  color: #2563eb;
}

.pagination-wrap {
  display: flex;
  justify-content: flex-end;
  margin: 18px 0 4px;
}

.query-panel {
  padding: 18px;
  margin-bottom: 14px;
}

.query-fields {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
}

.query-actions {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  margin-top: 16px;
}

.page-actions {
  display: flex;
  justify-content: flex-start;
  gap: 10px;
  margin-bottom: 12px;
}

.query-control {
  width: 220px;
}



.coordinate-input-row {
  display: flex;
  align-items: center;
  gap: 10px;
}

.coordinate-input-row .el-input {
  flex: 1;
  min-width: 0;
  width: auto;
}

.coordinate-tool-link {
  flex: 0 0 auto;
  color: #409eff;
  font-size: 12px;
  text-decoration: none;
  white-space: nowrap;
}

.coordinate-tool-link:hover {
  color: #66b1ff;
  text-decoration: underline;
}
.manage-form {
  overflow: hidden;
}

.manage-form .el-select,
.manage-form .el-input,
.manage-form .el-input-number {
  width: 100%;
}

.manage-form ::v-deep .el-form-item__label {
  white-space: nowrap;
}

.field-tip,
.upload-tip {
  margin-top: 6px;
  line-height: 1.5;
  font-size: 12px;
  color: #8a96a8;
}
</style>

<style>
.manage-dialog {
  max-width: calc(100vw - 48px);
  border-radius: 18px;
  overflow: hidden;
}

.manage-dialog .el-dialog__body {
  max-height: 72vh;
  overflow-y: auto;
  overflow-x: hidden;
  padding-right: 28px;
}
</style>
